/* eslint-disable @typescript-eslint/no-empty-interface */
// Libraries
import React from 'react';

// Components
import {CardBlock, CardText} from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import {IMetadata} from 'Components/flowChart/components/NodePreview/components/NodeWaitEvent/types';
import {INodePreviewProps} from 'Components/flowChart/components/NodePreview/types';

// Utils
import {getObjectPropSafely} from 'Utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEvent/index.tsx';

export interface INodeWaitEvent extends INodePreviewProps<IMetadata> {}

const NodeWaitEvent: React.FC<INodeWaitEvent> = (props) => {
	try {
		const {
			node: {metadata},
			lookupData
		} = props;
		const {waitingEvents} = metadata;

		if (waitingEvents?.length) {
			return (
				<>
					{waitingEvents.map((event, index) => {
						const eventName = getObjectPropSafely(
							() => lookupData!.events[event.eventTrackingName].eventNameDisplay,
							event.eventTrackingName
						);

						return (
							<CardBlock key={`${eventName}-${index}`}>
								<CardText>{eventName}</CardText>
							</CardBlock>
						);
					})}
				</>
			);
		}

		return null;
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeWaitEvent',
			args: {props}
		});

		return null;
	}
};

export default NodeWaitEvent;
